module.exports = __webpack_public_path__ + "static/media/dentaldentures.d2265eea.png";